/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonstitle2Inputs */

const en_listingbuttonstitle2 = /** @type {(inputs: Listingbuttonstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buttons in the app`)
};

const de_listingbuttonstitle2 = /** @type {(inputs: Listingbuttonstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knöpfe in der App`)
};

/**
* | output |
* | --- |
* | "Buttons in the app" |
*
* @param {Listingbuttonstitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonstitle2 = /** @type {((inputs?: Listingbuttonstitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonstitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonstitle2(inputs)
	return de_listingbuttonstitle2(inputs)
});
export { listingbuttonstitle2 as "listingButtonsTitle" }